import { getColumnsForType } from "./columns.js";

function normalizeStandardType(type) {
  if (type === "creator") return "creator";
  if (type === "expert") return "expert";
  if (type === "component" || type === "plugin" || type === "vector" || type === "site" || type === "tutorial")
    return type;
  return "template";
}

function getHeaderAlignClass(type, columnId) {
  if (type === "creator") return columnId === "name" ? "text-left" : "text-center";
  return columnId === "name" || columnId === "author" ? "text-left" : "text-center";
}

function getNoResultsAlignClass(type, columnId) {
  if (type === "creator") return columnId === "name" ? "text-left" : "text-center";
  if (columnId === "name" || columnId === "author") return "text-left";
  return "text-center";
}

function renderSortArrowsHtml() {
  return `<span class="sort-arrows-container"><span class="sort-arrow sort-arrow-up"><svg width="7" height="5" viewBox="0 0 8 6" fill="currentColor"><path d="M4 0 L8 6 L0 6 Z" /></svg></span><span class="sort-arrow sort-arrow-down"><svg width="7" height="5" viewBox="0 0 8 6" fill="currentColor"><path d="M4 0 L8 6 L0 6 Z" /></svg></span></span>`;
}

function renderTopTooltip(contentHtml, tooltipText) {
  return `${contentHtml}<div class="tooltip top"><div class="tooltip-item">${tooltipText}</div></div>`;
}

function renderHeaderCell(type, column) {
  const sortableClass = column.sortable ? "sortable cursor-pointer" : "";
  const dataColumn = column.sortable ? ` data-column="${column.id}"` : "";
  const labelHtml =
    column.labelHtml ||
    (column.sortable ? `<span class="sortable-header">${column.label || ""}</span>` : column.label || "");
  const arrowsHtml = column.sortable ? ` ${renderSortArrowsHtml()}` : "";
  return `<th class="${sortableClass} h-auto py-4 ${getHeaderAlignClass(type, column.id)} ${column.headerClass}"${dataColumn}>${labelHtml}${arrowsHtml}</th>`;
}

function renderStandardFooterCell(column) {
  if (column.id === "rank") {
    const content = '<div class="tfoot-rank-total">-</div><div class="tfoot-rank-breakdown">- / -</div>';
    return `<td class="${column.footerClass} text-center with-tooltip" id="tfoot-rank">${renderTopTooltip(content, "Items total<br/>free / paid")}</td>`;
  }
  if (column.id === "change") {
    const content =
      '<div class="tfoot-change-events"><span class="tfoot-change-new">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-movedin">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-comeback">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-price">-</span></div>';
    return `<td class="${column.footerClass} text-center with-tooltip" id="tfoot-change">${content}<div class="tooltip top"><div class="tooltip-item tfoot-change-tooltip-item"><div class="tfoot-change-tooltip-line tfoot-change-tooltip-new-line">new: <span class="tfoot-change-tooltip-value tfoot-change-tooltip-value-new">-</span><span class="tfoot-change-tooltip-desc">(published today)</span></div><div class="tfoot-change-tooltip-line tfoot-change-tooltip-movedin-line">moved-in: <span class="tfoot-change-tooltip-value tfoot-change-tooltip-value-movedin">-</span><span class="tfoot-change-tooltip-desc">(items changed category)</span></div><div class="tfoot-change-tooltip-line tfoot-change-tooltip-comeback-line">comeback: <span class="tfoot-change-tooltip-value tfoot-change-tooltip-value-comeback">-</span><span class="tfoot-change-tooltip-desc">(was previously unlisted, is back today)</span></div><div class="tfoot-change-tooltip-line tfoot-change-tooltip-repriced-line">repriced: <span class="tfoot-change-tooltip-value tfoot-change-tooltip-value-repriced">-</span><span class="tfoot-change-tooltip-desc">(switch free&lt;-&gt;paid category)</span></div></div></div></td>`;
  }
  if (column.id === "toppercent") return `<td class="${column.footerClass} text-center" id="tfoot-toppercent">-</td>`;
  if (column.id === "trend") return `<td class="${column.footerClass} text-center">-</td>`;
  if (column.id === "price") {
    const content = '<div class="tfoot-price-label">avg / mid</div><div class="tfoot-price-values">- / -</div>';
    return `<td class="${column.footerClass} text-center with-tooltip" id="tfoot-price">${renderTopTooltip(content, "Average price vs median price")}</td>`;
  }
  if (column.id === "image") return `<td class="${column.footerClass}"></td>`;
  if (column.id === "name") return `<td class="${column.footerClass} text-left" id="tfoot-name">-</td>`;
  if (column.id === "categories") return `<td class="${column.footerClass} text-center" id="tfoot-categories"></td>`;
  if (column.id === "medals") return `<td class="${column.footerClass} text-center" id="tfoot-medals"></td>`;
  if (column.id === "author") return `<td class="${column.footerClass} text-left" id="tfoot-author">-</td>`;
  return `<td class="${column.footerClass}">-</td>`;
}

function renderCreatorFooterCell(column) {
  if (column.id === "name") {
    return `<td class="text-left creators-col-name ${column.footerClass}" id="tfoot-creators-count">-</td>`;
  }
  if (column.id === "templates") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-templates">-</td>`;
  }
  if (column.id === "templatesdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-templatesdelta">-</td>`;
  }
  if (column.id === "components") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-components">-</td>`;
  }
  if (column.id === "componentsdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-componentsdelta">-</td>`;
  }
  if (column.id === "plugins") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-plugins">-</td>`;
  }
  if (column.id === "pluginsdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-pluginsdelta">-</td>`;
  }
  if (column.id === "vectors") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-vectors">-</td>`;
  }
  if (column.id === "vectorsdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-vectorsdelta">-</td>`;
  }
  if (column.id === "tutorials") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-tutorials">-</td>`;
  }
  if (column.id === "tutorialsdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-tutorialsdelta">-</td>`;
  }
  if (column.id === "total") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-total">-</td>`;
  }
  if (column.id === "totaldelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-totaldelta">-</td>`;
  }
  const isDelta =
    column.id === "templatesdelta" ||
    column.id === "componentsdelta" ||
    column.id === "pluginsdelta" ||
    column.id === "vectorsdelta" ||
    column.id === "tutorialsdelta" ||
    column.id === "totaldelta";
  return `<td class="${isDelta ? "creators-col-delta" : "creators-col-metric"} ${column.footerClass}"></td>`;
}

function renderNoResultsCell(type, column, message) {
  const align = getNoResultsAlignClass(type, column.id);
  if (column.id === "name") {
    return `<td class="${column.cellClass} ${align} ranks-no-results-message">${message}</td>`;
  }
  if (column.id === "image" || column.id === "medals") {
    return `<td class="${column.cellClass} ${align}"></td>`;
  }
  return `<td class="${column.cellClass} ${align}">-</td>`;
}

export function buildNoResultsRow(type, message = "No results found") {
  const normalizedType = normalizeStandardType(type);
  const columns = getColumnsForType(normalizedType);
  const cells = columns.map((column) => renderNoResultsCell(normalizedType, column, message)).join("");
  return `<tr class="clusterize-no-data ranks-no-results">${cells}</tr>`;
}

export function buildTableStructureHtml(standardType = "template", options = {}) {
  const normalizedStandardType = normalizeStandardType(standardType);
  const standardColumns = getColumnsForType(
    normalizedStandardType === "creator" ? "template" : normalizedStandardType,
    options,
  );
  const creatorColumns = getColumnsForType("creator");

  const standardHeaderHtml = standardColumns.map((column) => renderHeaderCell(normalizedStandardType, column)).join("");
  const creatorHeaderHtml = creatorColumns.map((column) => renderHeaderCell("creator", column)).join("");
  const standardFooterHtml = standardColumns.map((column) => renderStandardFooterCell(column)).join("");
  const creatorFooterHtml = creatorColumns.map((column) => renderCreatorFooterCell(column)).join("");

  return {
    thead: `<tr id="standard-thead-row" class="standard-head">${standardHeaderHtml}</tr><tr id="creators-thead-row" class="creators-head">${creatorHeaderHtml}</tr>`,
    tfoot: `<tr id="standard-tfoot-row" class="standard-foot">${standardFooterHtml}</tr><tr id="creators-tfoot-row" class="creators-foot">${creatorFooterHtml}</tr>`,
  };
}

export function mountTableStructure({ thead, tfoot, standardType = "template", categoryDisplayMode } = {}) {
  if (!thead || !tfoot) return;
  const structure = buildTableStructureHtml(standardType, { categoryDisplayMode });
  thead.innerHTML = structure.thead;
  tfoot.innerHTML = structure.tfoot;
}
